// Helpers for placing the text caret in a contentEditable that has just
// switched into edit mode. The fields only become editable after a state
// change, so the browser's native "caret lands where you clicked" never gets a
// chance to run — we have to reproduce it from the saved click coordinates.

// Resolve a viewport point (clientX/clientY) to a collapsed DOM Range.
// caretRangeFromPoint is Chrome/Safari; caretPositionFromPoint is Firefox.
const rangeFromPoint = (x, y) => {
  if (document.caretRangeFromPoint) {
    return document.caretRangeFromPoint(x, y);
  }
  if (document.caretPositionFromPoint) {
    const pos = document.caretPositionFromPoint(x, y);
    if (!pos) return null;
    const range = document.createRange();
    range.setStart(pos.offsetNode, pos.offset);
    range.collapse(true);
    return range;
  }
  return null;
};

// Focus `el` and place the caret. If `point` ({x, y} of the click that started
// editing) resolves to a spot inside `el`, drop the caret there; otherwise fall
// back to the end of the content (e.g. editing was started from the keyboard).
// Focuses with preventScroll so a long field doesn't jump to bring the
// (previously end-of-text) caret into view.
export const placeCaret = (el, point) => {
  if (!el) return;
  const selection = window.getSelection();
  let range = point ? rangeFromPoint(point.x, point.y) : null;
  if (!range || !el.contains(range.startContainer)) {
    range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false); // collapse to end
  }
  el.focus({ preventScroll: true });
  selection.removeAllRanges();
  selection.addRange(range);
};
